import { lazy } from 'react';
import { Route } from 'react-router-dom';

import { RequireRole } from '@/core/permissions';

const HomeworkPage = lazy(() =>
  import('./pages/HomeworkPage').then(m => ({ default: m.HomeworkPage }))
);
const HomeworkEditorPage = lazy(() =>
  import('./pages/HomeworkEditorPage').then(m => ({ default: m.HomeworkEditorPage }))
);
const HomeworkSubmissionsPage = lazy(() =>
  import('./pages/HomeworkSubmissionsPage').then(m => ({ default: m.HomeworkSubmissionsPage }))
);
const HomeworkDetailPage = lazy(() =>
  import('./pages/HomeworkDetailPage').then(m => ({ default: m.HomeworkDetailPage }))
);
const ChildrenPage = lazy(() =>
  import('./pages/ChildrenPage').then(m => ({ default: m.ChildrenPage }))
);

/**
 * Homework routes, gated exactly like the API (ADR-014): staff author and
 * review, pupils read and hand in, parents get their own `/children` read —
 * `/homework` itself 403s for them.
 */
export const homeworkRoutes = (
  <>
    <Route element={<RequireRole roles={['admin', 'teacher', 'pupil']} />}>
      <Route path="/homework" element={<HomeworkPage />} />
    </Route>
    <Route element={<RequireRole roles={['admin', 'teacher']} />}>
      <Route path="/homework/:publicId/edit" element={<HomeworkEditorPage />} />
      <Route path="/homework/:publicId/submissions" element={<HomeworkSubmissionsPage />} />
    </Route>
    <Route element={<RequireRole roles={['pupil']} />}>
      <Route path="/homework/:publicId" element={<HomeworkDetailPage />} />
    </Route>
    <Route element={<RequireRole roles={['parent']} />}>
      <Route path="/children" element={<ChildrenPage />} />
    </Route>
  </>
);
